import { ENDPOINT_ROOT, ENDPOINT_WISHLISTS } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const patchWishlist = ({ wishlist, items }) =>
  axiosAuth
    .patch(`${ENDPOINT_ROOT}/${ENDPOINT_WISHLISTS}/${wishlist.id}`, { items })
    .then((res) => res.data);

export default patchWishlist;
